import { useOnlineStatus } from '@/hooks/useOnlineStatus';

const InternetConnectionStatus = () => {
  const online = useOnlineStatus();

  return (
    <>
      {online ? null : (
        <div
          style={{
            zIndex: 3000,
            position: 'fixed',
            top: '0px',
            left: '0px',
            width: '100vw',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'var(--tractie-color-background-overlay)',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px',
              alignItems: 'center',
              color: 'var(--tractie-color-content-default-inverse)',
              fontSize: '16px',
              fontWeight: 600,
              lineHeight: '24px',
            }}
          >
            <span>Live-verbinding verloren.</span>
            <span>Controleer je internetverbinding</span>
            <span style={{ paddingTop: '8px' }}>(BAM probeert opnieuw over 4 seconden...)</span>
          </div>
        </div>
      )}
    </>
  );
};

export default InternetConnectionStatus;
